import { request } from './request'
import { under2Camal, camel2Under } from '../utils/camal-case-covertor';
const baseURL = process.env.VUE_APP_BASEURL_BI
const api = '/template/query/name/v1'

// 数据大屏-地区成交额
export const getBigScreencountryData = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.screen.country',
      params
    }
  })
}
// 新数据大屏-国家销售地图
export const newGetBigScreencountryData = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.screen.country_sale_report',
      params
    }
  })
}
export const newGetBigScreencountryLnglat = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.country.conf',
      params
    }
  })
}
// 新数据大屏-首屏概览(月维度)
export const newGetBigScreencMonthData = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.screen.overview_month',
      params
    }
  })
}
// 新数据大屏-首屏概览(日维度)
export const newGetBigScreencDayData = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.screen.overview_day',
      params
    }
  })
}
// 新数据大屏-店铺日成交排行榜
export const newGetBigScreencShopData = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.screen.shop_sale_list',
      params
    }
  })
}
// 新数据大屏-SPU日销量排行榜
export const newGetBigScreencSpuSaleData = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.screen.spu_sale_list',
      params
    }
  })
}
// 数据大屏-当月累计
export const getBigScreenMonthData = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.screen.month',
      params
    }
  })
}
// 数据大屏-当天累计
export const getBigScreenDayData = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.screen.today',
      params
    }
  })
}
// 数据大屏-月度热销商品
export const getBigScreenProductData = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.screen.product',
      params
    }
  })
}
// 数据大屏-当月订单渠道来源
export const getBigScreenOrderData = params => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.screen.channel',
      params
    }
  })
}

// 经营日报-成交额
export const getDayCount = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.daily.turnover',
      params: data
    }
  })
}
// 经营日报-成交额
export const getDayAdCount = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.daily.ad',
      params: data
    }
  })
}
// 经营月报 card

export const getMonthCount = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.month.turnover',
      params: data
    }
  })
}

// 订单链路看板-数据概览
export const getOrderOverview = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.order.overview',
      params: data
    }
  })
}
// 订单链路看板-未配货子订单
export const getUndispSuborder = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.undisp.suborder',
      params: data
    }
  })
}
// 订单链路看板-未配货子订单
export const getWaitshipDispcher = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.waitship.dispcher',
      params: data
    }
  })
}
// 订单链路看板-在途配货单
export const getOnshipDispcher = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.onship.dispcher',
      params: data
    }
  })
}
// 订单链路看板-妥投配货单
export const getReceiveDispcher = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.receive.dispcher',
      params: data
    }
  })
}
// template通用下载接口
export const templateDownload = (template_id, data, report_name, token, fn) => {
  return new Promise((resolve, reject) => {
    request({
      method: 'post',
      url: `${baseURL}/template/download/v1`,
      data: {
        template_id,
        params: camel2Under(data),
        report_name: report_name || template_id
      },
      withCredentials: false,
      responseType: "blob",
      headers: {
        responseType: "blob",
        token: true,
        "Content-Type": "application/json",
        Authorization: token,
        Accept: "application/octet-stream",
      },
    }).then(function (response) {
      if (response.status == 200) {
        var blob = new Blob([response.response.data], {
          type: 'application/vnd.ms-excel'
        })
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', `${report_name}.xlsx`)
        document.body.appendChild(link)
        link.click()
        resolve(200)
      } else {
        reject(500)
      }
      if (fn) fn()
    })
  })
}
// 供应链看板-概览
export const getSupplierOverview = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.supplier.overview',
      params: data
    }
  })
}
// 供应链看板-配货情况-图表
export const getDistributeChart = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.distribute.chart',
      params: data
    }
  })
}
// 供应链看板-配货情况-概览
export const getDistributeOverview = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.distribute.overview',
      params: data
    }
  })
}
// 供应链看板-上网情况-图表
export const getInternetChart = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.internet.chart',
      params: data
    }
  })
}
// 供应链看板-上网情况-概览
export const getInternetOverview = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.internet.overview',
      params: data
    }
  })
}
// 供应链看板-妥投情况-图表
export const getReceiveChart = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.receive.chart',
      params: data
    }
  })
}
// 供应链看板-妥投情况-概览
export const getReceiveOverview = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.receive.overview',
      params: data
    }
  })
}
// 商品售卖情况分析-地区成交退款额
export const getAreaRefund = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.area.sale',
      params: data
    }
  })
}
// 商品售卖情况分析-销量前十城市概况(全球)
export const getCityRange = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.sale.top10',
      params: data
    }
  })
}
// 商品售卖情况分析-品类销售概况(全球)
export const getSaleCategoryForWorld = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.category.sale.overview',
      params: data
    }
  })
}
// 商品售卖情况分析-品类销售趋势(全品类)
export const getSaleCategoryTrend = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.category.sale.trend',
      params: data
    }
  })
}
// 商品售卖情况分析-品类销售概况(spu维度)
export const getSaleCategoryForSpu = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.category.sale.trend.spu',
      params: data
    }
  })
}
// 商品售卖情况分析-商品品类查询接口
export const getCategoryList = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.category.list',
      params: data
    }
  })
}
// 商品售卖情况分析-商品spu查询接口
export const getSpuList = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.spu.list',
      params: data
    }
  })
}

// 库存管理-库存概览 卡片数据
export const getStockData = (data) => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.product.sale.stock.overview',
      params: data
    }
  })
}

// 库存管理-库存概览 列表数据
export const getStockTableData = (data) => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.product.sale.stock.detail',
      params: data
    }
  })
}

// 库存管理-库存概览  列表线图
export const getStickLineData = (data) => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.Integration.stock.sale.trend',
      params: data
    }
  })
}

// 库存管理-库存概览  供应商列表
export const getSuppliersList = (data) => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.product.supply.search',
      params: data
    }
  })
}

// 库存管理-获取类目
export const getProdCategories = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.product.category.search',
      params: data
    }
  })
}

// 爬虫
export const getReptileData = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.reptile.visualization',
      params: data
    }
  })
}

// 订单概况-数据概览
export const getOrderAnalysisOverview = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.order.analyse',
      params: data
    }
  })
}
// 订单概况-物流时长分析
export const getOrderAnalysisLogistics = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.ship.day',
      params: data
    }
  })
}
// 订单概况--发货时效分布
export const getOrderAnalysisDeliver = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.deliver.distribute',
      params: data
    }
  })
}
// 订单概况-履约时效分布
export const getOrderAnalysisPerform = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.perform.distribute',
      params: data
    }
  })
}
// 订单概况-订单详情
export const getOrderAnalysisDetail = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.order.detail',
      params: data
    }
  })
}
// 订单概况-订单商品列表
export const getOrderAnalysisGoodsList = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.sku.detail',
      params: data
    }
  })
}

// 顾客概况
export const getCustomerOverview = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.overview',
      params: data
    }
  })
}
// 平均顾客概况
export const getCustomerAvgOverview = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.avg.overview',
      params: data
    }
  })
}
// 顾客属性占比
export const getCustomerAttribute = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.attribute',
      params: data
    }
  })
}
// 近半年新客趋势
export const getCustomerNewTrend = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.new.trend',
      params: data
    }
  })
}
// 顾客复购漏斗
export const getCustomerReorder = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.reorder.funnel',
      params: data
    }
  })
}
// 顾客列表
export const getCustomerList = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.list',
      params: data
    }
  })
}
// 顾客列表-购物历史
export const getCustomerHistoryList = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.shopping.history',
      params: data
    }
  })
}
// 顾客列表-购物历史-商品数量弹窗
export const getCustomerHistorySkuList = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.shopping.history.sku',
      params: data
    }
  })
}
// 顾客列表-收货地址
export const getCustomerAddress = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.shipping.address',
      params: data
    }
  })
}
// 顾客详情_基础信息+详细信息
export const getCustomerDetail = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.detail',
      params: data
    }
  })
}
// 顾客详情_注册概况
export const getCustomerRegister = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.customer.register',
      params: data
    }
  })
}
// 广告分析——广告概览
export const postAdData = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.overview',
      params: data
    }
  })
}
// 广告分析——广告花费top5
export const getAdcostTop = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.all.spend.top5',
      params: data
    }
  })
}
// 广告分析--广告成交额top5
export const getPayamountTop = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.all.payamount.top5',
      params: data
    }
  })
}
// 广告分析——广告ROItop5
export const getROITop = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.all.roi.top5',
      params: data
    }
  })
}
// 广告分析——广告系列不同维度top5
export const getCampaignTop = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.all.campaign.top5',
      params: data
    }
  })
}
// 广告分析——广告营销趋势
export const getMarketTrend = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.all.market.trend',
      params: data
    }
  })
}

// 广告分析——广告详情列表
export const getAdTableDetail = (data) => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.detail',
      params: data
    }
  })
}

// 广告分析—fb—趋势对比
export const getFbTrend = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.fb.market.trend',
      params: data
    }
  })
}

// 广告分析—fb—广告营销漏斗
export const getFbTrans = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.fb.trans',
      params: data
    }
  })
}
// 广告分析—fb—广告营销漏斗
export const getShopList = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.brand.search',
      params: data
    }
  })
}
// 广告分析—fb—广告营销漏斗
export const getAdAccountList = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.ad.account.list',
      params: data
    }
  })
}
// 绩效分析—销售目标达成
export const getPerforTarget = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.perfor.target',
      params: data
    }
  })
}
// 绩效分析—团队排行榜
export const getPerforTeamRank = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.perfor.team.rank',
      params: data
    }
  })
}
// 绩效分析—优化师排行榜
export const getPerforOptimistRank = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.perfor.optimist.rank',
      params: data
    }
  })
}
// 绩效分析—店铺成交额排行榜
export const getPerforBrandRank = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.perfor.brand.rank',
      params: data
    }
  })
}
// 绩效分析—绩效趋势
export const getPerforSaleTrend = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.perfor.sale.trend',
      params: data
    }
  })
}
// 绩效分析—绩效详情
export const getPerforDetail = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.perfor.detail',
      params: data
    }
  })
}
// 经营日报-分时监控
export const getDailyHour = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'load.shoplus.bi.daily.hour',
      params: data
    }
  })
}
// 经营日报-概览
export const getDailyOverview = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'shoplus.bi.daily.overview',
      params: data
    }
  })
}
// 经营日报-概览趋势
export const getDailyOverviewTrend = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'shoplus.bi.daily.trend',
      params: data
    }
  })
}
// 经营日报-分时监控
export const getDailyMonitor = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'shoplus.bi.daily.hour.monitor',
      params: data
    }
  })
}
// 经营日报-店铺销售排行
export const getDailySalesTop = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'shoplus.bi.daily.brand.top',
      params: data
    }
  })
}
// 经营日报-SPU销售排行
export const getDailySpuSalesTop = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'shoplus.bi.daily.spu.top',
      params: data
    }
  })
}
// 经营日报-优化师排行
export const getDailyOptimizerTop = data => {
  return request({
    method: 'post',
    url: `${baseURL}${api}`,
    data: {
      template_id: 'shoplus.bi.daily.optimizer.top',
      params: data
    }
  })
}